import script from "./LegalNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&setup=true&lang=ts"

import "./LegalNotice.vue?vue&type=style&index=0&id=f206e9bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f206e9bc"]])

export default __exports__